import React from "react";
import Avatar from "../../assets/icons/img/avatar/avatar.png";

interface ImageWithTextProps {
  imageUrl: JSX.Element | string;
  text: string;
  size?: number;
  className?: string;
  showText?: boolean;
}

export const ImageWithText: React.FC<ImageWithTextProps> = ({
  imageUrl,
  text,
  size = 70,
  className = "",
  showText = true,
}) => {
  const displayImage = imageUrl === "no image" ? Avatar : imageUrl;

  return (
    <div
      className={`d-flex flex-column align-items-center border ${className} pointer`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        padding: "4px",
      }}
    >
      {typeof displayImage === "string" ? (
        <img
          src={displayImage}
          alt={text}
          className="rounded-circle"
          style={{
            width: `${size - 20}px`,
            height: `${size - 20}px`,
            objectFit: "contain",
          }}
        />
      ) : (
        <div
          style={{
            width: `${size - 45}px`,
            height: `${size - 45}px`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {displayImage}
        </div>
      )}
      {showText && (
        <div
          className="text-center mt-1"
          style={{
            fontSize: "12px",
            lineHeight: "1.2",
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default ImageWithText;
